import { render, staticRenderFns } from "./CustomOptionSelectorObject.vue?vue&type=template&id=0eda44b1&scoped=true&"
import script from "./CustomOptionSelectorObject.vue?vue&type=script&lang=js&"
export * from "./CustomOptionSelectorObject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eda44b1",
  null
  
)

export default component.exports